
// import React, { useEffect, useState, useMemo } from "react";

// const Logisticsorderdetails = () => {
//     const [activeTab] = useState("Overview");
//     const [offersData, setOffersData] = useState([]);
//     const [filteredOffersData, setFilteredOffersData] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [selectedDate, setSelectedDate] = useState("");

//     // NEW: Filter states like Userdetails file
//     const [searchType, setSearchType] = useState("id"); // Changed from "offerId" to "id"
//     const [searchQuery, setSearchQuery] = useState("");
//     const [statusFilter, setStatusFilter] = useState("");

//     // Search options for dropdown - updated field names
//     const searchOptions = [
//         { value: "id", label: "Offer ID" }, // Changed from "offerId" to "id"
//         { value: "orderId", label: "Order ID" }, // Add this line
//         { value: "partnerId", label: "Partner ID" },
//         { value: "userName", label: "User Name" },
//         { value: "userPhone", label: "User Phone" },
//         { value: "vendorRestaurentname", label: "Vendor Restaurant" }
//     ];

//     // Status options for dropdown
//     const statusOptions = [
//         { value: "", label: "All Status" },
//         { value: "DELIVERED", label: "Delivered" },
//         { value: "REJECTED", label: "Rejected" },
//         // { value: "ACCEPTED", label: "Accepted" },
//         // { value: "PENDING", label: "Pending" }
//     ];

//     // Fetch offers data
//     useEffect(() => {
//         const fetchOffersData = async () => {
//             setLoading(true);
//             try {
//                 const token = localStorage.getItem("authToken");
//                 if (!token) {
//                     console.error("No auth token found");
//                     setOffersData([]);
//                     return;
//                 }

//                 const response = await fetch(
//                     "https://backend.maamaas.com/delivery/api/admin/get/all/offers",
//                     {
//                         headers: {
//                             Authorization: `Bearer ${token}`,
//                         },
//                     }
//                 );

//                 if (!response.ok) {
//                     throw new Error(`HTTP error! status: ${response.status}`);
//                 }

//                 const offersData = await response.json();
//                 console.log("📊 Offers data:", offersData);

//                 // Debug: Log first item to see field names
//                 if (offersData.length > 0) {
//                     console.log("📋 First offer item fields:", Object.keys(offersData[0]));
//                     console.log("📋 First offer item values:", offersData[0]);
//                 }

//                 setOffersData(Array.isArray(offersData) ? offersData : []);
//             } catch (error) {
//                 console.error("Error fetching offers data:", error);
//                 setOffersData([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchOffersData();
//     }, []);

//     // NEW: Get placeholder text based on search type
//     const getPlaceholderText = () => {
//         switch (searchType) {
//             case "id": return "Search Offer ID"; // Updated
//             case "orderId": return "Search Order ID"; // Add this line
//             case "partnerId": return "Search Partner ID";
//             case "userName": return "Search User Name";
//             case "userPhone": return "Search User Phone";
//             case "vendorRestaurentname": return "Search Vendor Restaurant";
//             default: return "Search...";
//         }
//     };

//     // NEW: Clear all filters
//     const clearAllFilters = () => {
//         setSearchQuery("");
//         setSelectedDate("");
//         setStatusFilter("");
//     };

//     // NEW: Search filtered data - FIXED search logic
//     const searchFilteredData = useMemo(() => {
//         if (!offersData.length) return [];

//         let data = offersData;

//         // Date filter
//         if (selectedDate) {
//             data = data.filter((item) => {
//                 if (!item.createdAt) return false;

//                 const itemDate = new Date(item.createdAt);
//                 const selected = new Date(selectedDate);

//                 return itemDate.getDate() === selected.getDate() &&
//                     itemDate.getMonth() === selected.getMonth() &&
//                     itemDate.getFullYear() === selected.getFullYear();
//             });
//         }

//         // Status filter
//         if (statusFilter) {
//             data = data.filter((item) => {
//                 if (!item.status) return false;
//                 return item.status === statusFilter;
//             });
//         }

//         // Search filter - FIXED: Handle different field names properly
//         if (searchQuery.trim()) {
//             const query = searchQuery.toLowerCase().trim();
//             data = data.filter((item) => {
//                 let fieldValue;

//                 // Map search type to actual field name in data
//                 switch (searchType) {
//                     case "id":
//                         fieldValue = item.id || item.offerId; // Try both id and offerId
//                         break;
//                     case "orderId": // Add this case
//                         fieldValue = item.orderId;
//                         break;
//                     case "partnerId":
//                         fieldValue = item.partnerId;
//                         break;
//                     case "userName":
//                         fieldValue = item.userName;
//                         break;
//                     case "userPhone":
//                         fieldValue = item.userPhone;
//                         break;
//                     case "vendorRestaurentname":
//                         fieldValue = item.vendorRestaurentname;
//                         break;
//                     default:
//                         fieldValue = item[searchType];
//                 }

//                 if (!fieldValue) return false;

//                 // Convert to string for searching
//                 const stringValue = String(fieldValue).toLowerCase();

//                 // Special handling for phone number search
//                 if (searchType === "userPhone") {
//                     const cleanUserPhone = stringValue.replace(/\D/g, '');
//                     const cleanQuery = query.replace(/\D/g, '');
//                     return stringValue.includes(query) || cleanUserPhone.includes(cleanQuery);
//                 }

//                 // For other fields
//                 return stringValue.includes(query);
//             });
//         }

//         console.log("🔍 Filtered data count:", data.length);
//         return data;
//     }, [offersData, selectedDate, statusFilter, searchQuery, searchType]);

//     // Apply filters to offers data
//     useEffect(() => {
//         setFilteredOffersData(searchFilteredData);
//     }, [searchFilteredData]);

//     // Export CSV function
//     const handleExport = () => {
//         const exportData = searchFilteredData.length > 0 ? searchFilteredData : offersData;

//         if (exportData.length === 0) {
//             alert("No data available for export.");
//             return;
//         }

//         const headersCSV = [
//             "S.No", "Offer ID", "Order ID", "Partner ID", "Status", "User Name", "User Phone",
//             "Vendor Restaurant", "Items", "Earning", "Vehicle Status", "Created At"
//         ];

//         const csvRows = exportData.map((item, index) => [
//             index + 1,
//             item.id || "",
//             item.orderId || "", // Add this line
//             item.partnerId || "",
//             item.status || "",
//             item.userName || "",
//             item.userPhone || "",
//             item.vendorRestaurentname || "",
//             item.items || "",
//             item.earning !== undefined ? `₹${item.earning}` : "",
//             item.vehicleStatus || "",
//             item.createdAt ? new Date(item.createdAt).toLocaleString() : ""
//         ]);

//         const csvString = [headersCSV.join(","), ...csvRows.map(r => r.join(","))].join("\r\n");

//         const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
//         const url = URL.createObjectURL(blob);

//         const link = document.createElement("a");
//         link.href = url;
//         link.download = `logistics_offers_${selectedDate || "all"}.csv`;
//         link.click();
//         URL.revokeObjectURL(url);
//     };

//     const customPurpleBg = {
//         backgroundColor: "rgb(230 109 51)",
//         color: "#fff",
//         border: "none",
//     };

//     const headerStyle = {
//         backgroundColor: "rgb(230 109 51)",
//         color: "#fff",
//         textAlign: "center",
//         padding: "8px",
//         border: "1px solid #ddd",
//         position: 'sticky',
//         top: 0,
//         zIndex: 100
//     };

//     const cellStyle = {
//         textAlign: "center",
//         padding: "8px",
//         border: "1px solid #ddd",
//     };

//     const tabContent = {
//         Overview: (
//             <div style={{ width: "100%", marginTop: "-35px", marginBottom: "50px", padding: "20px" }}>
//                 {/* NEW: FILTERS CONTAINER */}
//                 <div
//                     className="row g-2 mb-3 align-items-center"
//                     style={{ padding: "15px", borderRadius: "6px" }}
//                 >
//                     {/* Search Type Dropdown and Search Input */}
//                     <div className="col-md-auto col-12">
//                         <div className="d-flex align-items-center" style={{ gap: '10px' }}>
//                             {/* Search Type Dropdown */}
//                             <div style={{ minWidth: '150px' }}>
//                                 <select
//                                     className="form-select"
//                                     value={searchType}
//                                     onChange={(e) => setSearchType(e.target.value)}
//                                     style={{ height: "40px" }}
//                                 >
//                                     {searchOptions.map(option => (
//                                         <option key={option.value} value={option.value}>
//                                             {option.label}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>

//                             {/* Search Input */}
//                             <div style={{ minWidth: '200px' }}>
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     placeholder={getPlaceholderText()}
//                                     value={searchQuery}
//                                     onChange={(e) => setSearchQuery(e.target.value)}
//                                     style={{ height: "40px" }}
//                                 />
//                             </div>
//                         </div>
//                     </div>

//                     {/* Date Filter */}
//                     <div className="col-md-auto col-12">
//                         <input
//                             type="date"
//                             value={selectedDate}
//                             onChange={(e) => setSelectedDate(e.target.value)}
//                             style={{
//                                 backgroundColor: "rgb(230 109 51)",
//                                 color: "#fff",
//                                 border: "none",
//                                 height: "40px",
//                                 borderRadius: "4px",
//                                 padding: "0 10px",
//                                 minWidth: "150px"
//                             }}
//                         />
//                     </div>

//                     {/* Status Filter */}
//                     <div className="col-md-auto col-12">
//                         <select
//                             className="form-select"
//                             value={statusFilter}
//                             onChange={(e) => setStatusFilter(e.target.value)}
//                             style={{ maxWidth: '150px', height: "40px" }}
//                         >
//                             {statusOptions.map(option => (
//                                 <option key={option.value} value={option.value}>
//                                     {option.label}
//                                 </option>
//                             ))}
//                         </select>
//                     </div>

//                     {/* Clear Filters Button */}
//                     <div className="col-md-auto col-12">
//                         <button
//                             className="btn"
//                             onClick={clearAllFilters}
//                             style={{
//                                 backgroundColor: '#6c757d',
//                                 color: '#fff',
//                                 height: "40px",
//                                 padding: "0 15px"
//                             }}
//                         >
//                             Clear Filters
//                         </button>
//                     </div>

//                     {/* Export Button */}
//                     <div className="col-md col-12">
//                         <div className="d-flex justify-content-start justify-content-md-end">
//                             <button
//                                 className="btn"
//                                 onClick={handleExport}
//                                 style={{
//                                     backgroundColor: 'rgb(230 109 51)',
//                                     color: '#fff',
//                                     height: "40px",
//                                     padding: "0 20px"
//                                 }}
//                             >
//                                 Export
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Offers Table with Scroll */}
//                 <div
//                     className="table-responsive"
//                     style={{
//                         maxHeight: 'calc(100vh - 250px)',
//                         overflowY: 'auto',
//                         border: '1px solid #dee2e6',
//                         borderRadius: '6px'
//                     }}
//                 >
//                     <table
//                         className="table table-bordered table-striped align-middle"
//                         style={{ marginBottom: 0 }}
//                     >
//                         <thead style={{ position: 'sticky', top: 0, zIndex: 100 }}>
//                             <tr>
//                                 <th style={headerStyle}>S.No</th>
//                                 <th style={headerStyle}>Offer ID</th>
//                                 <th style={headerStyle}>Order ID</th> {/* Add this line */}
//                                 <th style={headerStyle}>Partner ID</th>
//                                 <th style={headerStyle}>Status</th>
//                                 <th style={headerStyle}>User Name</th>
//                                 <th style={headerStyle}>User Phone</th>
//                                 <th style={headerStyle}>Vendor Restaurant</th>
//                                 <th style={headerStyle}>Items</th>
//                                 <th style={headerStyle}>Earning</th>
//                                 <th style={headerStyle}>Vehicle Status</th>
//                                 <th style={headerStyle}>Created At</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {loading ? (
//                                 <tr>
//                                     <td colSpan="12" style={{ textAlign: 'center', fontStyle: 'italic', padding: '20px' }}>
//                                         Loading offers data...
//                                     </td>
//                                 </tr>
//                             ) : searchFilteredData.length > 0 ? (
//                                 searchFilteredData.map((item, index) => {
//                                     let createdAtDate = "N/A";
//                                     let createdAtTime = "N/A";

//                                     if (item.createdAt) {
//                                         const dateObj = new Date(item.createdAt);
//                                         // Format as date/month/year
//                                         createdAtDate = `${String(dateObj.getDate()).padStart(2, "0")}/${String(dateObj.getMonth() + 1).padStart(2, "0")}/${dateObj.getFullYear()}`;
//                                         // Format time as HH:MM AM/PM
//                                         createdAtTime = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
//                                     }

//                                     return (
//                                         <tr key={item.id || index}>
//                                             <td style={cellStyle}>{index + 1}</td>
//                                             <td style={cellStyle}>{item.id || "N/A"}</td>
//                                             <td style={cellStyle}>{item.orderId || "N/A"}</td> {/* Add this line */}
//                                             <td style={cellStyle}>{item.partnerId || "N/A"}</td>
//                                             <td style={cellStyle}>
//                                                 <span style={{
//                                                     backgroundColor: item.status === 'DELIVERED' ? '#28a745' :
//                                                         item.status === 'REJECTED' ? '#dc3545' :
//                                                             item.status === 'ACCEPTED' ? '#17a2b8' :
//                                                                 '#ffc107',
//                                                     color: item.status === 'DELIVERED' || item.status === 'REJECTED' || item.status === 'ACCEPTED' ? '#fff' : '#212529',
//                                                     padding: '3px 8px',
//                                                     borderRadius: '12px',
//                                                     fontSize: '0.85em',
//                                                     fontWeight: 'bold'
//                                                 }}>
//                                                     {item.status || "N/A"}
//                                                 </span>
//                                             </td>
//                                             <td style={cellStyle}>{item.userName || "N/A"}</td>
//                                             <td style={cellStyle}>{item.userPhone || "N/A"}</td>
//                                             <td style={cellStyle}>{item.vendorRestaurentname || "N/A"}</td>
//                                             <td style={cellStyle}>{item.items || "N/A"}</td>
//                                             <td style={cellStyle}>
//                                                 {item.earning !== undefined
//                                                     ? `₹${item.earning}`
//                                                     : "N/A"}
//                                             </td>
//                                             <td style={cellStyle}>{item.vehicleStatus || "N/A"}</td>
//                                             <td style={cellStyle}>
//                                                 <div>{createdAtDate}</div>
//                                                 <div style={{ fontSize: '0.85em', color: '#666' }}>{createdAtTime}</div>
//                                             </td>
//                                         </tr>
//                                     );
//                                 })
//                             ) : (
//                                 <tr>
//                                     <td colSpan="12" style={{ textAlign: 'center', fontStyle: 'italic', padding: '20px' }}>
//                                         {offersData.length === 0
//                                             ? "No offers data available."
//                                             : (searchQuery.trim() || selectedDate || statusFilter)
//                                                 ? "No offers found with the specified filters."
//                                                 : "No offers data available."}
//                                     </td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         ),
//     };

//     return (
//         <div style={{ padding: "20px", marginBottom: "50px" }}>
//             <div
//                 style={{
//                     overflowY: "auto",
//                     height: "calc(100vh - 100px)",
//                 }}
//             >
//                 <div>{tabContent[activeTab]}</div>
//             </div>
//         </div>
//     );
// };

// export default Logisticsorderdetails;





import React, { useEffect, useState, useMemo } from "react";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
        </svg>
    ),
    Filter: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3" />
        </svg>
    ),
    Export: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
    ),
    Clear: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Calendar: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
    ),
    Truck: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
            <rect x="1" y="3" width="15" height="13" />
            <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
            <circle cx="5.5" cy="18" r="2.5" />
            <circle cx="18.5" cy="18" r="2.5" />
        </svg>
    ),
    User: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
        </svg>
    ),
    Phone: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.574 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
    ),
    Vendor: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
    ),
    Money: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0b5e42" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
            <path d="M8 7h8M8 11h6M8 15h4" />
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6" />
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
        </svg>
    ),
    Status: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 5px',


        minHeight: '40vh'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'rgb(230 109 51)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    filtersContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '12px 0',
        borderBottom: '1px solid #edf2f7',
        marginBottom: '16px'
    },
    searchGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: '1 1 auto',
        minWidth: '280px'
    },
    select: {
        padding: '8px 12px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        background: 'white',
        fontSize: '13px',
        fontWeight: '500',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        minWidth: '140px',
        cursor: 'pointer'
    },
    input: {
        flex: '1',
        padding: '8px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        background: 'white',
        minWidth: '180px'
    },
    dateInput: {
        padding: '8px 12px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        background: 'white',
        minWidth: '140px'
    },
    button: {
        padding: '8px 16px',
        borderRadius: '8px',
        border: 'none',
        fontWeight: '500',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        height: '38px',
        whiteSpace: 'nowrap'
    },
    buttonPrimary: {
        background: 'rgb(230 109 51)',
        color: 'white'
    },
    buttonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    buttonExport: {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white'
    },
    tableWrapper: {
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '60vh',
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '1200px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    th: {
        padding: '10px 14px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'rgb(230 109 51)',
        borderBottom: '2px solid #d45a1a',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 14px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px',
        textAlign: 'center',
        verticalAlign: 'middle'
    },
    statusBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '600',
        letterSpacing: '0.3px'
    },
    statusDelivered: {
        background: '#c6f6d5',
        color: '#276749'
    },
    statusRejected: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    statusAccepted: {
        background: '#bee3f8',
        color: '#2a4365'
    },
    statusPending: {
        background: '#fefcbf',
        color: '#975a16'
    },
    statusDefault: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    statsBar: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        padding: '8px 0',
        fontSize: '12px',
        color: '#718096',
        flexWrap: 'wrap'
    },
    statItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
    },
    statNumber: {
        fontWeight: '600',
        color: '#2d3748'
    },
    earning: {
        fontWeight: '700',
        color: '#0b5e42'
    },
    dateTime: {
        fontSize: '12px',
        lineHeight: '1.4'
    },
    timeText: {
        fontSize: '11px',
        color: '#a0aec0'
    }
};

const Logisticsorderdetails = () => {
    const [activeTab] = useState("Overview");
    const [offersData, setOffersData] = useState([]);
    const [filteredOffersData, setFilteredOffersData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedDate, setSelectedDate] = useState("");
    const [isMobile, setIsMobile] = useState(false);

    const [searchType, setSearchType] = useState("id");
    const [searchQuery, setSearchQuery] = useState("");
    const [statusFilter, setStatusFilter] = useState("");

    const searchOptions = [
        { value: "id", label: "Offer ID" },
        { value: "orderId", label: "Order ID" },
        { value: "partnerId", label: "Partner ID" },
        { value: "userName", label: "User Name" },
        { value: "userPhone", label: "User Phone" },
        { value: "vendorRestaurentname", label: "Vendor Restaurant" }
    ];

    const statusOptions = [
        { value: "", label: "All Status" },
        { value: "DELIVERED", label: "Delivered" },
        { value: "REJECTED", label: "Rejected" },
        { value: "ACCEPTED", label: "Accepted" },
        { value: "PENDING", label: "Pending" }
    ];

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const fetchOffersData = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem("authToken");
                if (!token) {
                    console.error("No auth token found");
                    setOffersData([]);
                    return;
                }

                const response = await fetch(
                    "https://backend.maamaas.com/delivery/api/admin/get/all/offers",
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const offersData = await response.json();
                setOffersData(Array.isArray(offersData) ? offersData : []);
            } catch (error) {
                console.error("Error fetching offers data:", error);
                setOffersData([]);
            } finally {
                setLoading(false);
            }
        };

        fetchOffersData();
    }, []);

    const getPlaceholderText = () => {
        switch (searchType) {
            case "id": return "Search by Offer ID...";
            case "orderId": return "Search by Order ID...";
            case "partnerId": return "Search by Partner ID...";
            case "userName": return "Search by User Name...";
            case "userPhone": return "Search by User Phone...";
            case "vendorRestaurentname": return "Search by Vendor...";
            default: return "Search...";
        }
    };

    const clearAllFilters = () => {
        setSearchQuery("");
        setSelectedDate("");
        setStatusFilter("");
    };

    const searchFilteredData = useMemo(() => {
        if (!offersData.length) return [];

        let data = offersData;

        if (selectedDate) {
            data = data.filter((item) => {
                if (!item.createdAt) return false;
                const itemDate = new Date(item.createdAt);
                const selected = new Date(selectedDate);
                return itemDate.getDate() === selected.getDate() &&
                    itemDate.getMonth() === selected.getMonth() &&
                    itemDate.getFullYear() === selected.getFullYear();
            });
        }

        if (statusFilter) {
            data = data.filter((item) => item.status === statusFilter);
        }

        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            data = data.filter((item) => {
                let fieldValue;
                switch (searchType) {
                    case "id": fieldValue = item.id || item.offerId; break;
                    case "orderId": fieldValue = item.orderId; break;
                    case "partnerId": fieldValue = item.partnerId; break;
                    case "userName": fieldValue = item.userName; break;
                    case "userPhone": fieldValue = item.userPhone; break;
                    case "vendorRestaurentname": fieldValue = item.vendorRestaurentname; break;
                    default: fieldValue = item[searchType];
                }
                if (!fieldValue) return false;
                const stringValue = String(fieldValue).toLowerCase();
                if (searchType === "userPhone") {
                    const cleanUserPhone = stringValue.replace(/\D/g, '');
                    const cleanQuery = query.replace(/\D/g, '');
                    return stringValue.includes(query) || cleanUserPhone.includes(cleanQuery);
                }
                return stringValue.includes(query);
            });
        }

        return data;
    }, [offersData, selectedDate, statusFilter, searchQuery, searchType]);

    useEffect(() => {
        setFilteredOffersData(searchFilteredData);
    }, [searchFilteredData]);

    const handleExport = () => {
        const exportData = searchFilteredData.length > 0 ? searchFilteredData : offersData;

        if (exportData.length === 0) {
            alert("No data available for export.");
            return;
        }

        const headersCSV = [
            "S.No", "Offer ID", "Order ID", "Partner ID", "Status", "User Name", "User Phone",
            "Vendor Restaurant", "Items", "Earning", "Vehicle Status", "Created At"
        ];

        const csvRows = exportData.map((item, index) => [
            index + 1,
            item.id || "",
            item.orderId || "",
            item.partnerId || "",
            item.status || "",
            item.userName || "",
            item.userPhone || "",
            item.vendorRestaurentname || "",
            item.items || "",
            item.earning !== undefined ? `₹${item.earning}` : "",
            item.vehicleStatus || "",
            item.createdAt ? new Date(item.createdAt).toLocaleString() : ""
        ]);

        const csvString = [headersCSV.join(","), ...csvRows.map(r => r.join(","))].join("\r\n");
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `logistics_offers_${selectedDate || "all"}.csv`;
        link.click();
        URL.revokeObjectURL(url);
    };

    const getStatusBadge = (status) => {
        if (!status) return styles.statusDefault;
        switch (status) {
            case "DELIVERED": return styles.statusDelivered;
            case "REJECTED": return styles.statusRejected;
            case "ACCEPTED": return styles.statusAccepted;
            case "PENDING": return styles.statusPending;
            default: return styles.statusDefault;
        }
    };

    // Calculate stats
    const totalOffers = offersData.length;
    const totalEarnings = offersData.reduce((sum, item) => sum + (item.earning || 0), 0);
    const deliveredCount = offersData.filter(item => item.status === "DELIVERED").length;
    const rejectedCount = offersData.filter(item => item.status === "REJECTED").length;

    return (
        <div style={styles.container}>


            {/* Filters */}
            <div style={styles.filtersContainer}>
                <div style={styles.searchGroup}>
                    <select
                        value={searchType}
                        onChange={(e) => setSearchType(e.target.value)}
                        style={styles.select}
                    >
                        {searchOptions.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>

                    <input
                        type="text"
                        placeholder={getPlaceholderText()}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{
                            ...styles.input,
                            borderColor: searchQuery ? 'rgb(230 109 51)' : '#e2e8f0'
                        }}
                    />
                </div>

                <input
                    type="date"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    style={{
                        ...styles.dateInput,
                        borderColor: selectedDate ? 'rgb(230 109 51)' : '#e2e8f0'
                    }}
                />

                <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    style={{ ...styles.select, minWidth: '130px' }}
                >
                    {statusOptions.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>

                <button
                    onClick={clearAllFilters}
                    style={{ ...styles.button, ...styles.buttonSecondary }}
                >
                    <Icons.Clear /> Clear
                </button>

                <button
                    onClick={handleExport}
                    style={{ ...styles.button, ...styles.buttonExport }}
                >
                    <Icons.Export /> Export
                </button>
            </div>

            {/* Table */}
            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead style={styles.thead}>
                        <tr>
                            <th style={{ ...styles.th, width: '50px' }}>#</th>
                            <th style={styles.th}>Offer ID</th>
                            <th style={styles.th}>Order ID</th>
                            <th style={styles.th}>Partner ID</th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>Status</th>
                            <th style={styles.th}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    <Icons.User /> User
                                </div>
                            </th>
                            <th style={styles.th}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    <Icons.Phone /> Phone
                                </div>
                            </th>
                            <th style={styles.th}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    <Icons.Vendor /> Vendor
                                </div>
                            </th>
                            <th style={styles.th}>Items</th>
                            <th style={{ ...styles.th, textAlign: 'right' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'flex-end' }}>
                                    <Icons.Money /> Earning
                                </div>
                            </th>
                            <th style={styles.th}>Vehicle</th>
                            <th style={styles.th}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    <Icons.Calendar /> Created
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="12" style={{ padding: 0 }}>
                                    <div style={{ textAlign: 'center', padding: '40px' }}>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p style={{ marginTop: '16px', color: '#718096' }}>Loading offers data...</p>
                                    </div>
                                </td>
                            </tr>
                        ) : filteredOffersData.length > 0 ? (
                            filteredOffersData.map((item, index) => {
                                let createdAtDate = "N/A";
                                let createdAtTime = "N/A";
                                if (item.createdAt) {
                                    const dateObj = new Date(item.createdAt);
                                    createdAtDate = `${String(dateObj.getDate()).padStart(2, "0")}/${String(dateObj.getMonth() + 1).padStart(2, "0")}/${dateObj.getFullYear()}`;
                                    createdAtTime = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                                }

                                return (
                                    <tr
                                        key={item.id || index}
                                        style={{
                                            backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                            transition: 'background 0.15s ease'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc'}
                                    >
                                        <td style={{ ...styles.td, color: '#a0aec0' }}>{index + 1}</td>
                                        <td style={{ ...styles.td, fontWeight: '600', color: 'rgb(230 109 51)' }}>
                                            #{item.id || "N/A"}
                                        </td>
                                        <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px' }}>
                                            {item.orderId || "N/A"}
                                        </td>
                                        <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px' }}>
                                            {item.partnerId || "N/A"}
                                        </td>
                                        <td style={{ ...styles.td, textAlign: 'center' }}>
                                            <span style={{ ...styles.statusBadge, ...getStatusBadge(item.status) }}>
                                                {item.status || "N/A"}
                                            </span>
                                        </td>
                                        <td style={{ ...styles.td, fontWeight: '500' }}>{item.userName || "N/A"}</td>
                                        <td style={styles.td}>{item.userPhone || "N/A"}</td>
                                        <td style={styles.td}>{item.vendorRestaurentname || "N/A"}</td>
                                        <td style={{ ...styles.td, fontSize: '12px' }}>
                                            {item.items || "N/A"}
                                        </td>
                                        <td style={{ ...styles.td, textAlign: 'right', ...styles.earning }}>
                                            {item.earning !== undefined ? `₹${item.earning}` : "N/A"}
                                        </td>
                                        <td style={styles.td}>{item.vehicleStatus || "N/A"}</td>
                                        <td style={styles.td}>
                                            <div style={styles.dateTime}>
                                                <div>{createdAtDate}</div>
                                                <div style={styles.timeText}>{createdAtTime}</div>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="12" style={{ padding: 0 }}>
                                    <div style={styles.emptyState}>
                                        <Icons.NoData />
                                        <div style={styles.emptyStateText}>
                                            {offersData.length === 0 ? 'No offers found' : 'No offers match your filters'}
                                        </div>
                                        <div style={styles.emptyStateSubtext}>
                                            {offersData.length === 0
                                                ? 'Offers will appear here once they are created'
                                                : 'Try adjusting your filters to see more results'}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <style>{`
                @media (max-width: 768px) {
                    .filters-container {
                        flex-direction: column !important;
                        align-items: stretch !important;
                    }
                    
                    .search-group {
                        min-width: unset !important;
                        flex-wrap: wrap !important;
                    }
                    
                    .search-group select {
                        min-width: 100px !important;
                    }
                    
                    .search-group input {
                        min-width: 120px !important;
                    }
                    
                    .stats-bar {
                        gap: 8px !important;
                        font-size: 11px !important;
                    }
                    
                    .stats-bar span {
                        font-size: 11px !important;
                    }
                }

                @media (max-width: 480px) {
                    .table-container table {
                        font-size: 11px !important;
                    }
                    
                    .table-container table th,
                    .table-container table td {
                        padding: 6px 8px !important;
                        font-size: 10px !important;
                    }
                    
                    .stats-bar {
                        gap: 4px !important;
                    }
                    
                    .stats-bar span {
                        font-size: 10px !important;
                    }
                    
                    .status-badge {
                        font-size: 9px !important;
                        padding: 2px 8px !important;
                    }
                    
                    .search-group select {
                        min-width: 80px !important;
                        font-size: 11px !important;
                    }
                    
                    .search-group input {
                        min-width: 100px !important;
                        font-size: 11px !important;
                    }
                }

                ::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                }
                
                ::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                
                ::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 4px;
                }
                
                ::-webkit-scrollbar-thumb:hover {
                    background: #a1a1a1;
                }

                .spinner-border {
                    display: inline-block;
                    width: 2rem;
                    height: 2rem;
                    border: 0.25em solid currentColor;
                    border-right-color: transparent;
                    border-radius: 50%;
                    animation: spinner-border 0.75s linear infinite;
                }

                @keyframes spinner-border {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default Logisticsorderdetails;